import { render, staticRenderFns } from "./kiron.vue?vue&type=template&id=13fdcfe2&"
import script from "./kiron.vue?vue&type=script&lang=js&"
export * from "./kiron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports